var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYSim = function SvgYSim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 19,
    fill: "none",
    viewBox: "0 0 15 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B75332"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.04H0v3.701c.53.327 1.11.647 1.728.99l.204.112c.718.398 1.48.825 2.236 1.308 1.315.839 2.633 1.858 3.737 3.233.953-1.153 2.206-2.154 3.418-2.961A26 26 0 0 1 15 6.394zM15 7.76c-.824.394-1.904.973-2.989 1.696-1.155.77-2.284 1.682-3.121 2.684 2.155.033 4.299-.299 6.11-1.237z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12.28c-2.604 1.155-5.64 1.269-8.382.95A27.8 27.8 0 0 1 0 11.602v5.439h15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.263c1.526.64 4.029 1.418 6.76 1.735l.048.005C5.845 10.849 4.696 9.96 3.5 9.197c-.72-.46-1.452-.87-2.17-1.268l-.206-.114c-.381-.21-.759-.42-1.124-.63z"
  }))));
};
export { SvgYSim as ReactComponent };
export default "/_next/static/media/static/media/Y-sim.5be78f5178fe673c4f44699c120a3199svg";